import { Text, View } from "dripsy";
import AnimatedPressable from "./animated-pressable";
import React from "react";

function SwitchGroup({ label, value, onChange }: { label: string; value: boolean; onChange: (v: boolean) => void }) {
  const toggleSwitch = () => onChange(!value);

  return (
    <AnimatedPressable
      onPress={toggleSwitch}
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingTop: 12,
        paddingBottom: 12,
      }}
    >
      <View
        sx={{
          backgroundColor: value ? "$primary" : "$grey",
          width: 50,
          borderRadius: 360,
          overflow: "hidden",
          padding: 4,
          alignItems: value ? "flex-end" : "flex-start",
        }}
      >
        <View sx={{ backgroundColor: "#fff", height: 20, width: 20, borderRadius: 360 }} />
      </View>
      <Text
        sx={{
          fontSize: 16,
          fontWeight: "500",
          marginLeft: "$2",
          marginRight: "$4",
          flex: 1,
        }}
        selectable={false}
      >
        {label}
      </Text>
    </AnimatedPressable>
  );
}
export default SwitchGroup;
